"use strict";

import { Application } from "../../main/application.js";
import { Screen } from "../../systems/core/screen.js";
import { UISprite } from "../uiSprite.js";
import { Vector2 } from "../../math/vectors.js";

export class UILine extends UISprite {
    constructor(config) {
        let _onInitialize = config.onInitialize;
        config.onInitialize = undefined;
        
        config.textureID = "Empty";
        config.parent = Application.main.stage;
        super(config);

        this.from = config.from;
        this.to = config.to;
        this.lineWidth = config.lineWidth;

        this._refreshTransform = this._refreshLine;

        _onInitialize?.bind(this)(config);
        this.updateNow();
    }

    _refreshLine() {
        let fromPos = { x: 0, y: 0 };
        let toPos = { x: 0, y: 0 };

        if (this.from._refreshTransform === undefined) {
            fromPos.x = this.from.x - Screen.main.size.bounds.width / 2;
            fromPos.y = this.from.y - Screen.main.size.bounds.height / 2;
        } else {
            fromPos = this.from.getRealWorldPosition();
            fromPos.x -= Screen.main.size.bounds.width / 2;
            fromPos.y -= Screen.main.size.bounds.height / 2;
        }

        if (this.to._refreshTransform === undefined) {
            toPos.x = this.to.x - Screen.main.size.bounds.width / 2;
            toPos.y = this.to.y - Screen.main.size.bounds.height / 2;
        } else {
            toPos = this.to.getRealWorldPosition();
            toPos.x -= Screen.main.size.bounds.width / 2;
            toPos.y -= Screen.main.size.bounds.height / 2;
        }

        let position = Vector2.lerp(fromPos, toPos, 0.5);

        this.x = position.x;
        this.y = position.y;

        let dir = Vector2.subtract(fromPos, toPos);
        this.angle = Vector2.getAngle(dir);

        this.width = this.lineWidth;
        this.height = Vector2.magnitude(dir);
    }
}